/* istanbul ignore file */
import { createScopedInstanceAndLoader, getLanguage } from '@citrite/translate';
import type { LocaleKeys } from '../locales/allLocaleKeys';

const instance = createScopedInstanceAndLoader({
	namespace: 'permissions-pilet',
	localesLoaderMap: {
		en: () => import('../locales/en.json'),
		es: () => import('../locales/es.json'),
		ja: () => import('../locales/ja.json'),
		de: () => import('../locales/de.json'),
		fr: () => import('../locales/fr.json'),
		'pt-BR': () => import('../locales/pt-BR.json'),
		it: () => import('../locales/it.json'),
		nl: () => import('../locales/nl.json'),
	},
	compatibilityJSON: 'v4',
});

export type PluginTFunction = (key: LocaleKeys, options?: any) => string;

export const t: (str: string, opts?: any) => string = instance.t;

export const { LocalizationLoader } = instance;

export { getLanguage };
